import { useDispatch } from "react-redux";

import { dataActions } from "@src/services/state/dataReducer";
import type * as TDT from "@tradingdroid/frontends-types";

import { useDataState } from "./data";

export const useOptimizations = () => {
  const dispatch = useDispatch();
  const optimizations = useDataState().optimizations;

  const setOptimizations = (studies: TDT.ApiStudy[]) => {
    dispatch(dataActions.setOptimizations(studies));
  };

  const upsertOptimization = (study: TDT.ApiStudy) => {
    dispatch(dataActions.upsertOptimization(study));
  };

  const removeOptimization = (id: number) => {
    dispatch(dataActions.removeStateOptimization(id));
  };

  return {
    optimizations,
    setOptimizations,
    upsertOptimization,
    removeOptimization,
  };
};
